<div class="notes-component">
  <div class="background">
    <div class="notes-header" (click)="toggleNotesContent()">
      <div class="info">
        <span>Notes ({{notes_count}})</span>
        <img src="/assets/images/arrow-right-green.png" class="arrow" [ngClass]="expanded ? 'expanded' : ''">
      </div>
    </div>

    @if (expanded) {
      <div [@slideInOut] class="notes-component-content">
        @if (notes?.length == 0) {
          <div class="empty-text">There are no notes yet</div>
        }
        @if (notes?.length > 0) {
          <ul>
            @for (item of notes; track item) {
              <li>
                <app-note-item [note]="item"
                [clickReplyCallback]="setSelectedNote"></app-note-item>
                @if (item.children?.length > 0) {
                  <ul class="children">
                    @for (child of item.children; track child) {
                      <li>
                        <app-note-item [note]="child" [parent]="item"
                        [clickReplyCallback]="setSelectedNote"></app-note-item>
                      </li>
                    }
                  </ul>
                }
              </li>
            }
          </ul>
        }
      </div>
    }
  </div>

  @if (expanded) {
    <div [@slideInOut] class="response">
      <div class="notes-input-container">
        <div class="textarea-container">
          @if (noteToReply) {
            <div class="reply-to" appFsMask><span>&#64;</span>{{noteToReply.user.firstName}}</div>
          }
          <textarea [(ngModel)]="newNoteText" rows="1"
            [attr.placeholder]="noteToReply ? null : 'Leave your note'"
          [attr.readonly]="inputEnabled ? null : true" appFsMask></textarea>
          <div class="clear"></div>
        </div>
        @if (sendButtonEnabled) {
          <button [@fadeInOut] class="btn-green-outline" (click)="postNote()">Send</button>
        }
        @if (!sendButtonEnabled) {
          <svg [@fadeInOut] id="loader" width="16px" height="16px">
            <defs>
              <linearGradient id="PSgrad_0" x1="0%" x2="0%" y1="100%" y2="0%">
                <stop offset="0%" stop-color="rgb(35,150,127)" stop-opacity="0"></stop>
                <stop offset="100%" stop-color="rgb(35,150,127)" stop-opacity="1"></stop>
              </linearGradient>
            </defs>
            <path fill-rule="evenodd" fill-opacity="0" fill="rgb(58, 58, 58)"
            d="M8.000,16.000 C3.582,16.000 -0.000,12.418 -0.000,8.000 C-0.000,3.582 3.582,-0.000 8.000,-0.000 C12.418,-0.000 16.000,3.582 16.000,8.000 C16.000,12.418 12.418,16.000 8.000,16.000 ZM8.000,1.778 C4.563,1.778 1.778,4.564 1.778,8.000 C1.778,11.436 4.563,14.222 8.000,14.222 C11.436,14.222 14.222,11.436 14.222,8.000 C14.222,4.564 11.436,1.778 8.000,1.778 Z"></path>
            <path fill="url(#PSgrad_0)"
            d="M8.000,16.000 C3.582,16.000 -0.000,12.418 -0.000,8.000 C-0.000,3.582 3.582,-0.000 8.000,-0.000 C12.418,-0.000 16.000,3.582 16.000,8.000 C16.000,12.418 12.418,16.000 8.000,16.000 ZM8.000,1.778 C4.563,1.778 1.778,4.564 1.778,8.000 C1.778,11.436 4.563,14.222 8.000,14.222 C11.436,14.222 14.222,11.436 14.222,8.000 C14.222,4.564 11.436,1.778 8.000,1.778 Z"></path>
          </svg>
        }
      </div>
    </div>
  }
</div>
